export const DEPARTMENTS = [
  { id: "vendite", label: "Vendite", modules: ["clienti", "lead", "opportunita", "follow-up", "offerte", "forecast", "catalogo"] },
  { id: "amministrazione", label: "Ordini e fatturazione", modules: ["ordini", "ddt", "da-fatturare", "fatture", "proforma", "fatture-fornitori", "fornitori"] },
  { id: "operativita", label: "Operatività", modules: ["attivita", "calendario", "interventi", "rapportini", "moduli-tecnici"] },
  { id: "asset", label: "Asset e contratti", modules: ["prodotti-asset", "licenze", "contratti"] },
  { id: "documenti", label: "Documenti", modules: ["documenti-commerciali", "documenti", "password-manager"] },
  { id: "analisi", label: "Analisi", modules: ["analytics"] },
];

export const PRESETS = [
  { id: "it", label: "IT e tecnico", description: "Configurazione standard di ON! Suite.", hidden: [], labels: {} },
  {
    id: "servizi", label: "Servizi e consulenza", description: "Incarichi e report al posto di interventi e rapportini, senza asset.",
    hidden: ["asset"],
    labels: { "dept:operativita": "Progetti", interventi: "Incarichi", "interventi:one": "incarico", rapportini: "Report attività", "rapportini:one": "report attività", "moduli-tecnici": "Moduli collaboratori", catalogo: "Servizi", "catalogo:one": "listino servizi" },
  },
  {
    id: "installatori", label: "Installatori e impianti", description: "Lavori, schede lavoro e impianti dei clienti.",
    hidden: [],
    labels: { "dept:operativita": "Cantieri e lavori", "dept:asset": "Impianti e contratti", interventi: "Lavori", "interventi:one": "lavoro", rapportini: "Schede lavoro", "rapportini:one": "scheda lavoro", "prodotti-asset": "Impianti", "prodotti-asset:one": "impianto", licenze: "Scadenze", "licenze:one": "scadenza", "moduli-tecnici": "Moduli installatori" },
  },
  {
    id: "commercio", label: "Commercio", description: "Vendite, ordini e fatture; niente parte tecnica.",
    hidden: ["operativita", "asset"],
    labels: { catalogo: "Prodotti", "catalogo:one": "catalogo prodotti", opportunita: "Trattative", "opportunita:one": "trattativa" },
  },
];

// Parole cercate nei testi delle pagine: singolare / plurale (null = solo singolare) / genere
export const TERMS = {
  clienti: ["cliente", "clienti", "m"], lead: ["lead", "lead", "m"], opportunita: ["opportunità", "opportunità", "f"], offerte: ["offerta", "offerte", "f"],
  catalogo: ["catalogo", null, "m"], fornitori: ["fornitore", "fornitori", "m"], attivita: ["attività", "attività", "f"], interventi: ["intervento", "interventi", "m"],
  rapportini: ["rapportino", "rapportini", "m"], "prodotti-asset": ["asset", "asset", "m"], licenze: ["licenza", "licenze", "f"], contratti: ["contratto", "contratti", "m"],
};

export const termRules = (labels = {}) => Object.entries(TERMS)
  .filter(([id]) => labels[id] || labels[`${id}:one`])
  .map(([id, [one, many, gender]]) => {
    const newMany = labels[id] || labels[`${id}:one`];
    return { one, many, gender, newMany, newOne: labels[`${id}:one`] || newMany };
  });

const QUICK_DEPT = { attivita: "operativita", appuntamento: "operativita", intervento: "operativita", lead: "vendite", opportunita: "vendite", offerta: "vendite", cliente: "vendite" };

export const isHiddenModule = (ws, id) => DEPARTMENTS.some((d) => ws?.hidden_departments?.includes(d.id) && d.modules.includes(id));
export const isHiddenQuick = (ws, key) => !!ws?.hidden_departments?.includes(QUICK_DEPT[key]);

export const EMPTY_WORKSPACE = { sector: "it", hidden_departments: [], labels: {} };
